import { useState } from "react";
import { useTranslation } from "react-i18next";
import { Printer } from "lucide-react";
import { toast } from "sonner";
import { NeuButton, NeuCard } from "../../components/neu/Neu";
import { attendanceReport } from "../../api/attendanceReport";
import { openAttendanceWindow } from "./openAttendanceReport";
import { PeriodChip } from "../payroll/PeriodChip";
import { useReportBrand } from "../reports/useReportBrand";

// تقرير الحضور: نفس فلاتر الصفحة (شهر أو من/إلى) — زر واحد للفتح والطباعة.
export const AttendanceReportBar = ({ filters = {} }) => {
  const { t, i18n } = useTranslation();
  const brand = useReportBrand();
  const [busy, setBusy] = useState(false);
  const start = filters.start || filters.from_date || "";
  const end = filters.end || filters.to_date || "";
  const custom = Boolean(start && end);
  const scope = {
    ...(filters.branch_id && filters.branch_id !== "all" ? { branch_id: filters.branch_id } : {}),
    ...(filters.user_id && filters.user_id !== "all" ? { user_id: filters.user_id } : {}),
  };

  const open = async () => {
    setBusy(true);
    try {
      const params = custom
        ? { month: start.slice(0, 7), start, end }
        : { month: filters.month || new Date().toISOString().slice(0, 7) };
      const data = await attendanceReport({ lang: i18n.language, ...scope, ...params });
      if (!data.employees?.length) return toast.error(t("salaryReport.noData"));
      if (!openAttendanceWindow(data, i18n.language, { custom, brand })) {
        toast.error(t("salaryReport.popupBlocked"));
      }
    } catch {
      toast.error(t("errors.generic"));
    } finally {
      setBusy(false);
    }
  };

  return (
    <NeuCard className="flex flex-wrap items-center gap-3" data-testid="attendance-report-bar">
      <NeuButton variant="primary" className="flex items-center gap-2" data-testid="attendance-report-monthly"
                 disabled={busy} onClick={open}>
        <Printer className="h-4 w-4" /> {t("salaryReport.openPrint")}
      </NeuButton>
      <PeriodChip filters={filters} />
    </NeuCard>
  );
};
